export default __webpack_public_path__ + "static/media/HoweTrussImg.da46326b.png";